import { createContext, useContext, useState } from "react";

const ActionsContext = createContext();

export function useActions() {
  return useContext(ActionsContext);
}

export function ActionsProvider(props) {
    const [passwordReset, setPasswordReset] = useState(false);

    return (
    <ActionsContext.Provider
      value={{ passwordReset: passwordReset, setPasswordReset }}
    >
      {props.children}
    </ActionsContext.Provider>
  );
}